const config = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || "http://localhost:8000/api/v1",
  encryptionKey: import.meta.env.VITE_ENCRYPTION_KEY,
  superAdminEmail: import.meta.env.VITE_SUPER_ADMIN_EMAIL,
  superAdminPassword: import.meta.env.VITE_SUPER_ADMIN_PASSWORD,
  env: import.meta.env.MODE || "development",
  // "prototype" | "development" | "production"
  appMode: (import.meta.env.VITE_APP_MODE as string) || "development",
};

export default config;      